export interface NewsletterSetupStep {
  name: string;
  path: string;
  title: string;
  successKey?: string;
  warningKey?: string;
}

export const NEWSLETTER_SETUP_STEPS: Record<string, NewsletterSetupStep> = Object.freeze({
  recipients: {
    name: 'recipients',
    path: 'broadcasts.newsletter.setup.recipients',
    successKey: 'model.hasRecipientsAndSubPreference',
    warningKey: 'conditionsIncludeDraftedNewsletters',
    title: 'Recipients',
  },
  goal: {
    name: 'goal',
    path: 'broadcasts.newsletter.setup.tracking',
    successKey: 'model.validConversion',
    title: 'Goal',
  },
  content: {
    name: 'content',
    path: 'broadcasts.newsletter.setup.content',
    successKey: 'model.templatesReadyToSend',
    title: 'Content',
  },
  review: {
    name: 'review',
    path: 'broadcasts.newsletter.setup.review',
    title: 'Review',
  },
});

export const DEFAULT_NEWSLETTER_SETUP_STEPS = [
  NEWSLETTER_SETUP_STEPS.recipients,
  NEWSLETTER_SETUP_STEPS.goal,
  NEWSLETTER_SETUP_STEPS.content,
  NEWSLETTER_SETUP_STEPS.review,
];
